document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
      
        if (event.target.matches('.change-color-product-coll')) {
          
          const clickedElement = event.target;
           var main_product_id =  clickedElement.getAttribute('data-main-product-id');
            var color_product_id = clickedElement.getAttribute('data-product-color-id');     
            requestAnimationFrame(() => {
              console.log(1,main_product_id);
              document.getElementById(`${color_product_id}`).style.display = 'block';
              console.log(2,main_product_id);
              var pProductFamilyAllClasses = document.querySelectorAll(`.${main_product_id}`);
              pProductFamilyAllClasses.forEach(function(element) {
                    
                  if(!element.classList.contains(`${color_product_id}`)){
                    element.style.display = 'none';
                  }else{
                    element.style.display = 'block';
                  }
              });
          });
           const img_to_show_video_alternative = `video-alternative-sec-img-show-${main_product_id}`;
            var img_to_show_video_alternative_var = document.querySelectorAll(`.${img_to_show_video_alternative}`);
            img_to_show_video_alternative_var.forEach(function(element) {
              element.classList.add("product-card__image--primary");
              element.classList.remove("product-card__image--secondary");
            });
          
          const mainProductHandle = clickedElement.getAttribute('data-main-product-handle');
          var main_product = document.querySelector(`data-product-handle[handle="${mainProductHandle}"]`);

            // const productCardHandle = document.querySelector(`data-product-handle[handle="${mainProductHandle}"]`);
            // const productUrl = clickedElement.getAttribute('data-product-url');
            const productTitle = clickedElement.getAttribute('data-product-title');
            const productPrice = clickedElement.getAttribute('data-product-price');
            const productInfo = document.querySelector('.product-info-' + main_product_id);
            const productTitleElement = productInfo.querySelector('.grid-product__title');
            const productPriceElement = productInfo.querySelector('.grid-product__price');
            
            productPriceElement.querySelector('.price-now').innerText = productPrice;
            productPriceElement.querySelector('.grid-product__price--original').innerText = clickedElement.getAttribute('data-product-price-compare-at-price');
            productPriceElement.querySelector('.grid-product__price--savings').innerText = clickedElement.getAttribute('date-saved-amount-p');
          
          



          
            // productTitleElement.href = productUrl;
            productTitleElement.innerHTML = productTitle;
            // productPriceElement.innerHTML = productPrice;
            document.querySelectorAll(`button[data-main-product-id="${main_product_id}"]`).forEach(otf => {
                otf.classList.remove("color-sw-round-selected");
            });
            clickedElement.classList.add("color-sw-round-selected");
        }
    });
});
